import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'jhi-cart-value[label][value]',
  templateUrl: './cart-value.component.html',
  styleUrls: ['./cart-value.component.scss'],
})
export class CartValueComponent implements OnInit {
  @Input() label!: string;
  @Input() color = 'text-gray';
  @Input() currency = 'EUR';
  @Input() suffix?: string;
  @Input() options!: {
    withCurrency?: boolean;
    italic?: boolean;
    icon?: string;
    iconColor?: string;
    reverse?: boolean;
  };
  @Input() value!: any;

  _defaultOptions: { withCurrency?: boolean; italic?: boolean; icon?: string; iconColor?: string } = {
    withCurrency: true,
    italic: false,
  };

  ngOnInit(): void {
    this.options = { ...this._defaultOptions, ...this.options };
  }
}
